var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_337_4702",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 81,
    height: 80
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.001 0C17.9096 0 0.000976563 17.9086 0.000976563 40C0.000976563 62.0914 17.9096 80 40.001 80C62.0924 80 80.001 62.0914 80.001 40C80.001 17.9086 62.0924 0 40.001 0ZM40.001 15C26.1939 15 15.001 26.1929 15.001 40C15.001 53.8071 26.1939 65 40.001 65C53.8081 65 65.001 53.8071 65.001 40C65.001 26.1929 53.8081 15 40.001 15Z",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_337_4702)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.9385 64.0238L52.001 78.7746C39.401 81.2161 28.751 79.4528 25.001 78.2659L29.861 63C35.801 65.5758 43.361 65.0606 46.9385 64.0238Z",
    fill: "#A48262",
    stroke: "#A48262"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3259 63.1099L24.6736 77.8137C13.5997 71.9546 6.69702 63.9981 4.6299 60.7522L18.099 51.7674C21.5356 57.0924 25.1756 60.7644 30.3259 63.1099Z",
    fill: "#FEDC56",
    stroke: "#FEDC56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5695 53.5768L6.05245 61.8645C0.676083 51.7153 -0.297791 42.1127 -0.112682 38.5801L15.3251 38.6615C15.0567 44.4803 15.8595 49.1453 18.5695 53.5768Z",
    fill: "#F8A938",
    stroke: "#F8A938"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5829 38.3282L-0.65323 37.9587C0.9131 26.187 5.79032 17.4775 8.03314 14.5942L20.7289 23.7777C17.0647 28.5485 14.9675 32.9743 14.5829 38.3282Z",
    fill: "#EE654A",
    stroke: "#EE654A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.627 23.5598L8.66281 14.1188C16.9816 5.6438 26.1103 1.6054 29.6349 0.645579L34.2766 15.6113C28.4823 17.2276 24.1484 19.5085 20.627 23.5598Z",
    fill: "#ED4569",
    stroke: "#ED4569"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4045 15.5395L30.058 0.931872C41.7391 -1.20795 51.5281 0.746054 54.9624 1.99053L50.1411 16.8994C44.473 14.8848 39.6162 14.2545 34.4045 15.5395Z",
    fill: "#B8D34D",
    stroke: "#B8D34D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.8842 16.9892L54.9245 2.2494C65.517 7.67305 71.9654 15.3129 73.8656 18.4548L60.4049 27.7997C57.2433 22.6466 53.8242 19.1362 48.8842 16.9892Z",
    fill: "#56BB8C",
    stroke: "#56BB8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.6566 27.4674L74.2832 18.9324C79.834 29.4308 80.9116 39.3546 80.7566 43.0042L65.088 42.8854C65.3063 36.8739 64.4482 32.0521 61.6566 27.4674Z",
    fill: "#70CADB",
    stroke: "#70CADB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.6432 42.5634L79.8704 43.2024C78.0961 54.9446 73.0656 63.5664 70.7721 66.4096L58.2408 57.0029C61.9888 52.2977 64.1639 47.9097 64.6432 42.5634Z",
    fill: "#9E62A4",
    stroke: "#9E62A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5695 56.327L71.316 65.8439C63.9653 73.8398 55.6132 77.5016 52.3559 78.333L47.1848 63.6583C52.5376 62.2542 56.4831 60.1624 59.5695 56.327Z",
    fill: "#A46276",
    stroke: "#A46276"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHue);
export default __webpack_public_path__ + "static/media/hue.a2c4497696e5dc2f13ab9ae413a42a48.svg";
export { ForwardRef as ReactComponent };